import {
  $EnterABTest,
  $I18nText,
  $Locale,
  $RenderConfig,
  $UserAgent,
  $WebUser,
  $CSPScripts,
  $AppIdConfig,
} from '@lemon8/web-app-shared/atom';
import { $HomepageMaterial } from 'shared/atoms/homepage-material';
import { $HomepageCurrentTraffic, $HomepageEnterTraffic } from './traffic';

export const Atoms = {
  $Locale,
  $AppIdConfig,
  $EnterABTest,
  $RenderConfig,
  $WebUser,
  $UserAgent,
  $I18nText,
  $HomepageMaterial,
  $CSPScripts,
  $HomepageEnterTraffic,
  $HomepageCurrentTraffic,
};

export const AtomFamilies = {} as const;

export * from './enable-pinterest';
export * from './traffic';
